import React from 'react'
import { Route } from 'react-router-dom'
import RoutesWrapper from '../RoutesWrapper'

const Stage4 = React.lazy(
  () => import('../../pages/stages/stage4/Stage4Main'),
)
const Stage4Story = React.lazy(
  () => import('../../pages/stages/stage4/Stage4Story'),
)
const Stage4Ending = React.lazy(
  () => import('../../pages/stages/stage4/Stage4Ending'),
)

const loc = `stage4`

export const Stage4Routes = (
  <>
    <Route
      path="/stage4"
      element={
        <RoutesWrapper loc={loc}>
          <Stage4 />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage4/story"
      element={
        <RoutesWrapper loc={loc}>
          <Stage4Story />
        </RoutesWrapper>
      }
    />
    <Route
      path="/stage4/ending"
      element={
        <RoutesWrapper loc={loc}>
          <Stage4Ending />
        </RoutesWrapper>
      }
    />
  </>
)
